import(/* webpackMode: "eager" */ "/home/ubuntu/download/6936ec505a24100014f0e313/veriqon_pilot/src/app/compliance/page.tsx");
